interface NavigoRoute {
  url: string;
  name?: string;
  query: string;
}
export class AppRouter {
  public static ROUTEREVENT_RELOADURL = 'RELOADURL';
  public static ROUTEREVENT_ONROUTERAFTER = 'ONROUTERAFTER';
  public static ROUTEREVENT_ONROUTERBEFORE = 'ONROUTERBEFORE';

  private _router;
  private _dispatchRouterAfter;
  private _nextUrl: string = '';

  constructor(aConstructorParams) {
    this._createNewRouter(aConstructorParams.isCordova);

    this._router.hooks({
      before: (done, params) => {
        this._dispatchRouterAfter = true;
        this.onRouterBefore(done, params);
      },
      after: params => {
        if (this._dispatchRouterAfter) {
          this.onRouterAfter(params);
        }
      },
      leave: params => {
        var x = 4;
      },
      already: params => {
        var x = 4;
      },
    });

    // set the default routes
    this._router.on(() => {
      this._dispatchRouterAfter = false;
      console.log('+++ defaulthook, waiting and then going default');
      this.goToDefaultRoute();
    });

    // set the 404 route
    this._router.notFound((url, query) => {
      this._dispatchRouterAfter = false;
      setTimeout(() => {
        this.onPageNotFound(url, query);
      }, 100);
    });
  }

  public static canGoBack(): boolean {
    if (window.history.state && window.history.state.initial === true) {
      return false;
    }
    return true;
  }

  private _createNewRouter(isCordova): void {
    console.log('+++ _createNewRouter');

    if (window.location.href.includes('/v/auth#')) {
      window.location.href = window.location.href.replace('#', '?');
    }

    if (isCordova) {
      const base = window.location.href.match(/.+app\.html/g)[0] + '/';

      this._router = new Navigo(base, false, '#!');
      //this._router = new Navigo(null, true, '#!');
    } else {
      let getUrl = window.location;
      let baseUrl = getUrl.protocol + '//' + getUrl.host + '/';
      this._router = new Navigo(baseUrl, false, '#!');
    }
  }

  public back(): void {
    if (CrowdHub_App.CONFIG.VERBOSE_GENERAL_LOGGING) {
      console.info('AppRouter.back() called.');
    }
    window.history.back();
  }
  public forward(): void {
    if (CrowdHub_App.CONFIG.VERBOSE_GENERAL_LOGGING) {
      console.warn('AppRouter.forward function Not Implemented.');
    }
  }
  public reload(): void {
    if (CrowdHub_App.CONFIG.VERBOSE_GENERAL_LOGGING) {
      console.info('AppRouter.reload() called.');
    }
    console.log('+++ approuter.reload() destroy');
    this._router.destroy();
    App.INSTANCE.reloadLocation();
  }

  public destroy(): void {
    this._router?.destroy();
  }

  public routeExists(route): boolean {
    return this._router.routeExists(route);
  }

  public generate(aRoute: string, aRouteParams: {}): any {
    // TODO add site to path or check
    return this._router?.generate(aRoute, aRouteParams);
  }

  public addRouterEvent(eventPath: string, eventPathParams: {}): void {
    if (window.PLATFORM_DATA.Platform.Sites[0].Path == null) {
      this._router.on(eventPath, eventPathParams);
    } else {
      this._router.on(
        (window.PLATFORM_DATA.Platform.Sites[0].Path == '' ? '' : '/') +
          window.PLATFORM_DATA.Platform.Sites[0].Path +
          eventPath,
        eventPathParams,
      );
    }
  }

  public goToDefaultLoggedOutRoute(): void {
    let aLoggedOutUrl = CrowdHub_App.CONFIG.DEFAULT_LOGGEDOUT_AS
      ? this.generate(CrowdHub_App.CONFIG.DEFAULT_LOGGEDOUT_AS, {})
      : CrowdHub_App.CONFIG.DEFAULT_LOGGEDOUT_URL;
    if (aLoggedOutUrl == '') {
      console.warn(
        `DEFAULT_LOGGEDOUT_AS and DEFAULT_LOGGEDOUT_AS were not set properly in goToDefaultLoggedOutRoute(). Cannot generate a route from: ${CrowdHub_App.CONFIG.DEFAULT_LOGGEDOUT_AS}`,
      );
      aLoggedOutUrl = CrowdHub_App.CONFIG.REQUIRE_GLOBAL_LOGIN
        ? this.generate('navigate.landing', {})
        : this.generate('navigate.live.home', {});
    }
    this.route(aLoggedOutUrl);
  }

  public goToDefaultRoute(bustCache): void {
    App.INSTANCE.setHistoryState = null;

    setTimeout(() => {
      if (CrowdHub_App.CONFIG.VERBOSE_GENERAL_LOGGING) {
        console.info('+++goToDefaultRoute');
      }

      let aLoggedOutUrl = CrowdHub_App.CONFIG.DEFAULT_LOGGEDOUT_URL
        ? CrowdHub_App.CONFIG.DEFAULT_LOGGEDOUT_URL
        : this.generate(CrowdHub_App.CONFIG.DEFAULT_LOGGEDOUT_AS, {});
      let aLoggedInUrl = CrowdHub_App.CONFIG.DEFAULT_LOGGEDIN_URL
        ? CrowdHub_App.CONFIG.DEFAULT_LOGGEDIN_URL
        : this.generate(CrowdHub_App.CONFIG.DEFAULT_LOGGEDIN_AS, {});

      if (aLoggedOutUrl == '') {
        console.warn(
          `DEFAULT_LOGGEDOUT_AS was not set properly. Cannot generate a route from: ${CrowdHub_App.CONFIG.DEFAULT_LOGGEDOUT_AS}`,
        );
        aLoggedOutUrl = CrowdHub_App.CONFIG.REQUIRE_GLOBAL_LOGIN
          ? this.generate('navigate.landing', {})
          : this.generate('navigate.live.home', {});
      }

      if (bustCache) {
        aLoggedOutUrl = addCacheBust(aLoggedOutUrl);
        aLoggedInUrl = addCacheBust(aLoggedInUrl);

        if (CrowdHub_App.APPOPENURL != null) {
          CrowdHub_App.APPOPENURL = addCacheBust(CrowdHub_App.APPOPENURL);
        }
      }

      if (aLoggedInUrl == '') {
        console.warn(
          `DEFAULT_LOGGEDIN_AS was not set properly. Cannot generate a route from: ${CrowdHub_App.CONFIG.DEFAULT_LOGGEDIN_AS}`,
        );
        aLoggedInUrl = this.generate('navigate.live.home', {});
      }

      if (App.INSTANCE.CurrentUser.IsLoggedIn() == false) {
        this.route(aLoggedOutUrl);
      } else {
        let invitationId = mLocalStorage.get(CrowdHub_App.CONFIG.INVITATION_IDENTIFICATION);
        if (invitationId) {
          App.INSTANCE.setInvitationFinished(invitationId, aLoggedInUrl);
        } else {
          if (CrowdHub_App.APPOPENURL) {
            this.route(CrowdHub_App.APPOPENURL);
            if (!App.CORDOVA || window.location.href.indexOf('#!') == -1) {
              CrowdHub_App.APPOPENURL = null;
            }
          } else {
            this.route(aLoggedInUrl);
          }
        }
      }
    }, 100);
  }

  public onPageNotFound(url, query): void {
    console.log('+++onPageNotFound: ' + url + ' ? ' + query);
    if (
      window.PLATFORM_DATA.Platform.Sites[0].Path == null ||
      window.PLATFORM_DATA.Platform.Sites[0].Path.length == 0
    ) {
      this.goToDefaultRoute();
    } else if (this.lastRouteResolvedUrl().split('/')[1] == window.PLATFORM_DATA.Platform.Sites[0].Path) {
      this.goToDefaultRoute();
    } else {
      // usually we'll hit this on the first loginwithtoken, if we have params such as token_reroute we need to put them back in the url
      let queryParams = '';
      if (query && query != '') {
        queryParams = '?' + query;
      }

      let url =
        (window.PLATFORM_DATA.Platform.Sites[0].Path == '' ? '' : '/' + window.PLATFORM_DATA.Platform.Sites[0].Path) +
        this.lastRouteResolvedUrl() +
        queryParams;

      if (this.routeExists(url)) {
        this.route(url);
      } else {
        this.goToDefaultRoute();
      }
    }
  }

  public onRouterBefore(aDoneCallback: Function, params: NavigoRoute): void {
    // we are checking here to see if the url we are trying to go to is in this same site
    console.log(
      '+++ onRouterBefore this._nextUrl: ' +
        this._nextUrl +
        ', current loc ' +
        window.location.href +
        ', current hash + ' +
        window.location.hash,
    );

    let next = this._nextUrl.split('/');
    let nextSplit = next[0];
    if (next[0] == '' || next[0] == this.getHash()) {
      nextSplit = next[1];
    }

    if (
      window.PLATFORM_DATA.Platform.Sites[0].Path != null &&
      window.PLATFORM_DATA.Platform.Sites[0].Path != '' &&
      nextSplit &&
      nextSplit != '' &&
      nextSplit != window.PLATFORM_DATA.Platform.Sites[0].Path
    ) {
      // we have switched site via path
      console.log('+++ onRouterBefore RELOAD');
      console.log('+++ path is: ' + window.PLATFORM_DATA.Platform.Sites[0].Path);
      console.log('+++ nextSplit is: ' + nextSplit);
      localStorage.setItem('sso-login-attempted', 'false');

      this._router.destroy();
      App.INSTANCE.reloadLocation(this._nextUrl);

      console.log('+++ window.location.reload() destroy' + ', current loc ' + window.location.href);

      return;
    }

    if (!params) {
      params = this.lastRouteResolved();
    }

    // if still not params lets try to parse them from the tokenreroute if we have one and then set the initial location since this is where the login with magic link hits with the token_reroute
    if (!params) {
      let next = window.location.href.split('?');
      let reroute = next[1];

      if (reroute) {
        // if we have token_reroute query parameter, want to set magic link location based on query param value
        if (reroute.includes('token_reroute')) {
          console.log('+++set_magic_link_location 5');
          App.INSTANCE.setMagicLinkLocation(decodeURIComponent(reroute).split('=')[1]);
        }
      }
    }

    // Handle opening navigate.loginmodal directly, redirect to home
    if (params && params?.name === 'navigate.loginmodal' && this._nextUrl === '') {
      console.log('+++ Rerouting to home from loginmodal');
      App.INSTANCE.goToDefaultRoute();
    }

    // according to Navigo docs the done function MUST always be called to complete the onRouterBefore function call
    // obviously unless you return before it to break the callback

    if (App.INSTANCE.onRouterBefore(params)) {
      App.INSTANCE.dispatch(AppRouter.ROUTEREVENT_ONROUTERBEFORE, params);
      console.log('+++aDoneCallback');
      aDoneCallback();
    }

    return;
  }

  public onRouterAfter(params: NavigoRoute = { url: '', query: '' }): void {
    console.log('+++ onRouterafter, current loc: ' + window.location.href + ', current hash: ' + window.location.hash);

    App.INSTANCE.dispatch(AppRouter.ROUTEREVENT_ONROUTERAFTER, params);
    App.INSTANCE.onRouterAfter(params);
  }

  public route(aUrl: string, force = false): void {
    console.log(
      '+++ approuter route: ' +
        aUrl +
        ', current loc ' +
        window.location.href +
        ', current hash + ' +
        window.location.hash,
    );

    if (document.title.split(' - ').length > 1) {
      document.title = `${document.title.split(' - ')[0]}`;
    }

    aUrl = aUrl.replace('*|PATH|*', window.PLATFORM_DATA.Platform.Sites[0].Path);

    let aLastUrl = this.lastRouteResolved();
    if (force) {
      CrowdHub_App.LASTROUTE = null;
      this._nextUrl = aUrl;
      this._router?.navigate(aUrl); //.resolve();
    } else {
      if (
        aLastUrl != null &&
        aUrl &&
        (aUrl.replace('#!', '') == aLastUrl.url.replace('#!', '') ||
          '/' + aUrl.replace('#!', '') == aLastUrl.url.replace('#!', ''))
      ) {
        this._router?.navigate(aUrl); //.resolve();
        this.reloadUrl(aUrl);
      } else {
        this._nextUrl = aUrl;
        this._router?.navigate(aUrl); //.resolve();
      }
    }
  }

  public lastRouteResolved(): NavigoRoute {
    return this._router?.lastRouteResolved();
  }

  public getRouter(): Navigo {
    return this._router;
  }

  public getRoot(): string {
    return this._router?.root;
  }

  public getNextUrl(): string {
    return this._nextUrl;
  }

  public getHash(): string {
    return this._router?._hash;
  }

  public lastRouteResolvedUrl(): string {
    return this._router?.lastRouteResolved()?.url ? this._router?.lastRouteResolved().url : '';
  }

  public openExternalUrl(aUrl: string, isCordova: boolean = false): void {
    if (aUrl.indexOf('http') == -1) {
      aUrl = 'http://' + aUrl;
    }

    if (isCordova) {
      //compare to launchlink!
      if (CrowdHub_App.CONFIG.ASSOCIATED_DOMAIN) {
        if (aUrl.includes('https://' + CrowdHub_App.CONFIG.ASSOCIATED_DOMAIN)) {
          //this is a launch link!

          let params = null;
          if (aUrl.includes('?')) {
            params = parseQuery(aUrl.substring(aUrl.indexOf('?')));
          }

          const link = {
            path: aUrl,
            params: params,
          };

          processAppLaunchFromLink(link);
          return;
        }
      }

      var ref = cordova.InAppBrowser.open(aUrl, '_system', 'location=yes');
      // TODO do we want to do something with the ref?
    } else {
      window.open(aUrl, '_blank');
    }
  }

  public resolve(): void {
    this._router?.resolve();
  }

  public resolveHostSwitch(aUrl: string): void {
    // need to hide the side nav if thats where we came from so that if we are on the app we will refresh properly
    App.INSTANCE.showSideNav(false);
    // if the user is logged in, we need to split out the host we are trying to resolve and run it thru the tokenLogin
    if (App.INSTANCE.CurrentUser.IsLoggedIn()) {
      let hostDomain = new URL(aUrl);

      if (App.CORDOVA) {
        setMagicLinkInfo({
          token: App.INSTANCE.CurrentUser.Token,
          url: hostDomain.href,
          token_reroute: hostDomain.pathname == '/' ? null : hostDomain.pathname,
        });
      } else {
        let authUrl = `${hostDomain.origin}/tokenLogin/${
          App.INSTANCE.CurrentUser.Token
        }?token_reroute=${encodeURIComponent(hostDomain.pathname)}`;
        window.open(authUrl, '_self');
      }
    } else {
      // otherwise log them out of the site they are going to as well
      let hostDomain = new URL(aUrl);

      if (App.CORDOVA) {
        // technically speaking you cant navigate the app logged out but this is here just in case
        setMagicLinkInfo({
          token: -1,
          url: hostDomain.href,
          token_reroute: hostDomain.pathname == '/' ? null : hostDomain.pathname,
        });
      } else {
        let authUrl = `${hostDomain.origin}/tokenLogin/-1?token_reroute=${encodeURIComponent(hostDomain.pathname)}`;
        window.open(authUrl, '_self');
      }
    }
  }

  public resetRoutes(): void {
    if (this._router) {
      this._router._routes = [];
    }
  }

  public reloadUrl(aUrl: string): void {
    App.INSTANCE.dispatch(AppRouter.ROUTEREVENT_RELOADURL, aUrl);
  }

  public setDocTitle(aContentName: string): void {
    document.title = `${document.title.split(CrowdHub_App.LANG.SOCIAL_TITLE_SEPARATOR)[0]}${
      CrowdHub_App.LANG.SOCIAL_TITLE_SEPARATOR
    }${aContentName}`;
  }

  public handleJwtUrl(aJWTUrl: string): void {
    var jwt = App.INSTANCE.CurrentUser.toJWT();
    App.INSTANCE.showLoading(true);

    $.ajax({
      type: 'POST',
      url: aJWTUrl,
      data: jwt,
      success: data => {
        App.INSTANCE.showLoading(false);
        window.open(data);
      },
      error: (textStatus, errorThrown) => {
        console.error(errorThrown);
        App.INSTANCE.showLoading(false);
        // ! TODO WTF did not know this existed!
        App.INSTANCE.showTextMessage('Try Again');
      },
    });
  }
}
